import React from 'react'

import { useHistory, useParams } from 'react-router-dom'

import { Container, LoadingFeedback, Page } from 'components'
import AiInventoryForm from './components/AiInventoryForm'

import useFetch from 'hooks/useFetch'

import { routes } from 'Routes'
import * as service from 'service'

const AiInventoryShow = () => {
  const history = useHistory()
  const { aiInventoryId } = useParams()

  const { response, isLoading } = useFetch(
    service.dponet.aiInventory.show,
    aiInventoryId,
    [aiInventoryId],
  )

  const aiInventory = response?.data?.aiInventoryItem || null

  return (
    <Page title="Inventário de IA">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading} />
        {aiInventory && (
          <AiInventoryForm
            mode="show"
            aiInventory={aiInventory}
            onStepSubmit={() => {}}
            onBack={() => history.push(routes.aiInventory.all)}
          />
        )}
      </Container>
    </Page>
  )
}

export default AiInventoryShow
